import { BASKET_TYPES, selectBasketCanEdit } from 'containers/OrderDetails/basketSlice'
import useVanUpsell from 'containers/OrderDetails/VanUpsell/useVanUpsell'
import useWarehouseName from 'hooks/useWarehouseName'
import { LOCATION_STATES } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import DeliveryItem from './DeliveryItem'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import ListItem from './ListItem'
import React from 'react'

const type = process.env.REACT_APP_TYPE

interface ListProps {
  list: any[]
}

const List: React.FC<ListProps> = ({ list }) => {
  const canEdit = useReduxSelector(selectBasketCanEdit)
  const { push, replace, goBack } = useHistory()
  const { t } = useTranslation('basket')
  const getName = useWarehouseName()
  const config = useReduxSelector(selectConfig)

  const storageItem = list.find(l => l.type === BASKET_TYPES.rent && !l.rentalUpsellFor)
  const showVanUpsell = type === 'ldz01'
    && !!config?.rentalUpsellEnabled
    && canEdit !== 0
    && !!storageItem
    && !list.some(l => l.type === BASKET_TYPES.rent && l.rentalUpsellFor)
  // auta w wypożyczalni dla skrytki z koszyka — przy jednym od razu modal z terminem zamiast sklepiku
  const vanUpsell = useVanUpsell(showVanUpsell ? storageItem.identifier : undefined)

  return (
    <div className='basketPopup__list'>
      {list.map((data) => {
        if (data.type === BASKET_TYPES.shop && data.related) return null
        return <ListItem
          {...data}
          name={getName(data)}
          key={data.identifier}
          isOnlyOnePositionInTheBasket={list.length === 1}
        />
      })}
      <DeliveryItem />
      {showVanUpsell && <div className='basketPopup__upsell'>
        <span className='basketPopup__upsell__title --secFont'>{t('vanUpsellTitle')}</span>
        <span className='basketPopup__upsell__desc'>{t('vanUpsellDesc')}</span>
        <button
          className='basketPopup__upsell__btn'
          onClick={() => {
            const orderPath = `/order/${storageItem.identifier}`
            if (vanUpsell.data?.products.length === 1) {
              // szczegóły skrytki + osobny wpis z modalem, żeby zamknięcie modala wracało do szczegółów zamówienia
              replace(orderPath)
              push(orderPath, LOCATION_STATES.popup({ type: 'rental', data: vanUpsell.data.featured }))
              return
            }
            replace(`${orderPath}/shop`)
          }}>
          {t('vanUpsellBtn')}
        </button>
      </div>}
      {canEdit !== 0 && <button
        className='button --coupon'
        onClick={() => {
          if (list?.some(l => l.type === BASKET_TYPES.rent)) {
            push(window.location.pathname, LOCATION_STATES.popup('newMag'))
          } else if (window.location.pathname.includes('shop')) {
            goBack()
          } else {
            replace('/shop')
          }
        }}>
        <span className='--secFont'>+ {t(type === 'ldz01' ? 'addAnotherOneStorage' : 'addAnotherOne')}</span>
      </button>}
    </div>
  )
}

export default List